Vue.component("SplashScreenHotspot", {
    props: ["hotspot", "index", "settings", "resetHotspot", "activeHotspot"],
    template: `
        <div class="SplashScreenHotspot" 
            :style="[{left: hotspot.x + 'px', top: hotspot.y + 'px'}]"
            @click="goto(hotspot)"
            >

            Videre <i>
                <img src="assets/img/ui/arrow.png" />
            </i>
        </div>
    `,
    methods: {
        goto(hotspot) {
            // Call goto() in PageScene
            this.$emit("goto", hotspot)
        },
    }

})